import { ReactNode } from "react";

import WorkspaceWrapper from "../WorkspaceWrapper";

// ---------------------------------------------------------------------------
// Phase 6 of STATE_MANAGEMENT_MIGRATION_PLAN.md
//
// The workspace state now lives in the Zustand store
// (src/stores/workspace/workspaceStore.ts). The React Context pattern
// (WorkspaceContext + WorkspaceDispatchContext) is no longer needed for new
// code. This file is preserved solely as a backward-compatible provider shell
// so that existing component trees that mount <WorkspaceProvider> continue to
// work without changes.
//
// Consumers should migrate to:
//   import { useWorkspaceStore, selectXxx } from "stores/workspace/workspaceStore";
//
// Removal deadline: end of Phase 7 cleanup.
// ---------------------------------------------------------------------------

export interface WorkspaceProviderModel {
  children: ReactNode;
  /** @deprecated No longer used — state is in Zustand. Kept for API compat. */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  state?: any;
  /** When false, skips rendering the WorkspaceWrapper orchestration layer. */
  useWrapper?: boolean;
}

/**
 * @deprecated Prefer mounting `<WorkspaceWrapper>` directly or using the
 * Zustand store. This provider is a thin pass-through kept for backward
 * compatibility during migration.
 */
export function WorkspaceProvider({ children, useWrapper }: WorkspaceProviderModel) {
  if (useWrapper === false) {
    return <>{children}</>;
  }

  return <WorkspaceWrapper>{children}</WorkspaceWrapper>;
}
